import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { take, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { RouteService } from '../_services/route.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public messages: object = null;

  constructor(
    private auth: AuthService,
    private router: Router,
    private authService: AuthService,
    private routeService: RouteService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.user.pipe(
      take(1),
      map(user => {
        if (!user && environment.protected) {
          this.authService.setRedirectUrl(state.url);
          this.router.navigateByUrl(this.getRedirectUrl(route, state));

          return false;
        } else {
          return true;
        }
      })
    );
  }

  getToken(state: RouterStateSnapshot) {
    let token = this.routeService.getQueryParam('token');
    if (token) {
      return token;
    }

    token = state.root.queryParams.token;

    return token ? token : null;
  }

  getRedirectUrl(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    const token = this.getToken(state);
    let redirectUrl = this.router.url;
    if (redirectUrl === '/') {
      redirectUrl = '/' + route.url[0].path;
    }
    if (token) {
      redirectUrl = redirectUrl + '?token=' + token;
    }

    return redirectUrl;
  }
}
